import { IOptionItem } from "@/components/ui/dropdown/types";

const NO_GEOMETRY_OPTIONS: IOptionItem[] = [
  {
    label: "Administrative Area",
    value: "adm_area"
  },
  {
    label: "Point",
    value: "poi"
  },
  {
    label: "Polygon",
    value: "polygon",
    disabled: true,
    description: "Geocoding not available"
  }
];

export const VALUE_TO_LABEL = {
  poi: "Point",
  polygon: "Polygon",
  adm_area: "Administrative Area",
  H3: "H3",
  geohash: "Geohash",
  line: "Line"
};

const SINGLE_GEOMETRY_OPTIONS: IOptionItem[] = [
  { label: "Point", value: "poi" },
  { label: "Polygon", value: "polygon" },
  { label: "Administrative Area", value: "adm_area" },
  { label: "Line", value: "line" },
  { label: "H3", value: "H3" },
  { label: "Geohash", value: "geohash" }
];

const MULTIPLE_GEOMETRY_OPTIONS: IOptionItem[] = [
  {
    label: "Point",
    value: "poi"
  },
  {
    label: "Polygon",
    value: "polygon"
  },
  {
    label: "Line",
    value: "line"
  },
  {
    label: "H3",
    value: "H3"
  },
  {
    label: "Geohash",
    value: "geohash"
  }
];

/** The hub also lets a multiple geometry dataset generate an ADM Area from a code column. */
const HUB_MULTIPLE_GEOMETRY_OPTIONS: IOptionItem[] = [
  ...MULTIPLE_GEOMETRY_OPTIONS,
  { label: "Administrative Area", value: "adm_area" }
];

const POINT_TYPE_OPTIONS: IOptionItem[] = [
  {
    label: "Coordinate",
    value: "coordinate"
  },
  {
    label: "Geocoding",
    value: "geocoding"
  }
];

const DATA_SETTING_ATTRIBUTE_COLUMN: IOptionItem[] = [
  { label: "Attribute Column 1", value: "Attribute Column 1" },
  { label: "Attribute Column 2", value: "Attribute Column 2" },
  { label: "Attribute Column 3", value: "Attribute Column 3" },
  { label: "Attribute Column 4", value: "Attribute Column 4" },
  { label: "Attribute Column 5", value: "Attribute Column 5" },
  { label: "Attribute Column 6", value: "Attribute Column 6" },
  { label: "Attribute Column 7", value: "Attribute Column 7" }
];

export {
  DATA_SETTING_ATTRIBUTE_COLUMN,
  HUB_MULTIPLE_GEOMETRY_OPTIONS,
  MULTIPLE_GEOMETRY_OPTIONS,
  NO_GEOMETRY_OPTIONS,
  POINT_TYPE_OPTIONS,
  SINGLE_GEOMETRY_OPTIONS
};
